import { render, staticRenderFns } from "./UserListTable.vue?vue&type=template&id=5bed5c53&lang=html"
import script from "./UserListTable.vue?vue&type=script&lang=js"
export * from "./UserListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports